'use client';
import React from 'react';
import { useParams } from 'next/navigation';
import { ImageObj } from '@custom-types/ImageObj.types';
import cn from './style.module.scss';

interface WildsLaunchLogoProps {
  logoImage: { ar: ImageObj; en: ImageObj };
}
export default function WildsLaunchLogo(props: WildsLaunchLogoProps) {
  const { lang } = useParams();
  const logoImage = lang === 'ar' ? props.logoImage.ar : props.logoImage.en;
  return (
    <div className={cn.LogoPane}>
      <img alt={logoImage?.url} src={logoImage?.url} />
    </div>
  );
}
